module.exports = __webpack_public_path__ + "static/social_listening-b69d2ead14e94d4224398355d9082c74.png";